import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, AlertIcon, Box, Button, Checkbox, Flex, Link, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, Tab, TabIndicator, TabList, TabPanel, TabPanels, Tabs, Text } from '@abb/uikit';
import { LoyaltyMemberStatus } from 'modules/Layout/models';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import FaydaIconDisable from 'shared-components/icons/FaydaPointDisable';
import { FaydaPointIcon } from 'shared-components/icons/FaydaPointIcon';
export const HowDoesItwork = (param)=>{
    let { terms, setTerms, data, isRegister, onClose, loyaltyStatus } = param;
    var _data_popupWording_generalInfo_programCashbackInfo, _data_popupWording_generalInfo, _data_popupWording, _data_popupWording_generalInfo1, _data_popupWording1, _data_customerBalanceInfo, _data_customerBalanceInfo1, _data_customerBalanceInfo2, _data_customerBalanceInfo3, _data_popupWording_generalInfo_programCashbackInfo1, _data_popupWording_generalInfo2, _data_popupWording2, _data_popupWording_generalInfo3, _data_popupWording3, _data_popupWording_generalInfo4, _data_popupWording4;
    const navigate = useNavigate();
    const { t } = useTranslation('common');
    let cashbackData = [];
    try {
        var _data_popupWording_generalInfo_programCashback, _data_popupWording_generalInfo5, _data_popupWording5, _data_popupWording_generalInfo6, _data_popupWording6;
        if (data === null || data === void 0 ? void 0 : (_data_popupWording5 = data.popupWording) === null || _data_popupWording5 === void 0 ? void 0 : (_data_popupWording_generalInfo5 = _data_popupWording5.generalInfo) === null || _data_popupWording_generalInfo5 === void 0 ? void 0 : (_data_popupWording_generalInfo_programCashback = _data_popupWording_generalInfo5.programCashback) === null || _data_popupWording_generalInfo_programCashback === void 0 ? void 0 : _data_popupWording_generalInfo_programCashback.key) cashbackData = JSON.parse(data === null || data === void 0 ? void 0 : (_data_popupWording6 = data.popupWording) === null || _data_popupWording6 === void 0 ? void 0 : (_data_popupWording_generalInfo6 = _data_popupWording6.generalInfo) === null || _data_popupWording_generalInfo6 === void 0 ? void 0 : _data_popupWording_generalInfo6.programCashback.key);
    } catch (error) {
        console.error('JSON parsing error:', error);
    }
    return /*#__PURE__*/ _jsxs(ModalContent, {
        mx: 4,
        maxW: "712px",
        borderRadius: "32px",
        children: [
            /*#__PURE__*/ _jsx(ModalCloseButton, {}),
            /*#__PURE__*/ _jsx(ModalHeader, {
                fontSize: "xx-large",
                children: data === null || data === void 0 ? void 0 : data.popupWording.generalInfo.title
            }),
            /*#__PURE__*/ _jsx(ModalBody, {
                maxH: "317px",
                overflow: "auto",
                children: !!data.customerBalanceInfo ? /*#__PURE__*/ _jsxs(Tabs, {
                    position: "relative",
                    variant: "unstyled",
                    children: [
                        /*#__PURE__*/ _jsxs(TabList, {
                            children: [
                                /*#__PURE__*/ _jsx(Tab, {
                                    _selected: {
                                        color: 'brand.abb.primary'
                                    },
                                    children: t('loyalty.balance')
                                }),
                                /*#__PURE__*/ _jsx(Tab, {
                                    _selected: {
                                        color: 'brand.abb.primary'
                                    },
                                    children: data === null || data === void 0 ? void 0 : data.popupWording.generalInfo.programInfo.key
                                }),
                                (data === null || data === void 0 ? void 0 : (_data_popupWording = data.popupWording) === null || _data_popupWording === void 0 ? void 0 : (_data_popupWording_generalInfo = _data_popupWording.generalInfo) === null || _data_popupWording_generalInfo === void 0 ? void 0 : (_data_popupWording_generalInfo_programCashbackInfo = _data_popupWording_generalInfo.programCashbackInfo) === null || _data_popupWording_generalInfo_programCashbackInfo === void 0 ? void 0 : _data_popupWording_generalInfo_programCashbackInfo.key) ? /*#__PURE__*/ _jsx(Tab, {
                                    _selected: {
                                        color: 'brand.abb.primary'
                                    },
                                    children: data === null || data === void 0 ? void 0 : (_data_popupWording1 = data.popupWording) === null || _data_popupWording1 === void 0 ? void 0 : (_data_popupWording_generalInfo1 = _data_popupWording1.generalInfo) === null || _data_popupWording_generalInfo1 === void 0 ? void 0 : _data_popupWording_generalInfo1.programCashbackInfo.key
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ _jsx(TabIndicator, {
                            mt: "-1.5px",
                            height: "2px",
                            bg: "brand.abb.primary",
                            borderRadius: "1px"
                        }),
                        /*#__PURE__*/ _jsxs(TabPanels, {
                            children: [
                                /*#__PURE__*/ _jsxs(TabPanel, {
                                    p: 0,
                                    mt: 5,
                                    children: [
                                        loyaltyStatus === LoyaltyMemberStatus.FROZEN_ACTIVE_MEMBER && /*#__PURE__*/ _jsxs(Alert, {
                                            status: "warning",
                                            borderRadius: "6px",
                                            mb: 4,
                                            children: [
                                                /*#__PURE__*/ _jsx(Box, {
                                                    mr: 2,
                                                    children: /*#__PURE__*/ _jsx(AlertIcon, {})
                                                }),
                                                t('loyalty.frozenInfo')
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Box, {
                                            border: "1px",
                                            borderColor: "semantic.onSurface.quaternary",
                                            borderRadius: "20px",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Flex, {
                                                    justifyContent: "space-between",
                                                    p: 5,
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Box, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    fontSize: "14px",
                                                                    children: t('loyalty.available_casback')
                                                                }),
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    fontSize: "12px",
                                                                    color: "semantic.onBackground.secondary",
                                                                    children: t('loyalty.cashback_expire')
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Flex, {
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            gap: "4px",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(FaydaPointIcon, {
                                                                    size: "20px"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    children: data === null || data === void 0 ? void 0 : (_data_customerBalanceInfo = data.customerBalanceInfo) === null || _data_customerBalanceInfo === void 0 ? void 0 : _data_customerBalanceInfo.activePoints
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Flex, {
                                                    borderTop: "1px",
                                                    borderBottom: "1px",
                                                    borderColor: "semantic.onSurface.quaternary",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    p: 5,
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Box, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    fontSize: "14px",
                                                                    children: t('loyalty.pending_cashback')
                                                                }),
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    color: "semantic.onBackground.secondary",
                                                                    fontSize: "12px",
                                                                    children: t('loyalty.update_cashback')
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Flex, {
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            gap: "4px",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(FaydaIconDisable, {}),
                                                                " ",
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    children: data === null || data === void 0 ? void 0 : (_data_customerBalanceInfo1 = data.customerBalanceInfo) === null || _data_customerBalanceInfo1 === void 0 ? void 0 : _data_customerBalanceInfo1.pendingPoints
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Flex, {
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    p: 5,
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Box, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    fontSize: "14px",
                                                                    children: t('loyalty.potential_cashback')
                                                                }),
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    fontSize: "12px",
                                                                    color: "semantic.onBackground.secondary",
                                                                    children: t('loyalty.max_cashback', {
                                                                        value: data === null || data === void 0 ? void 0 : (_data_customerBalanceInfo2 = data.customerBalanceInfo) === null || _data_customerBalanceInfo2 === void 0 ? void 0 : _data_customerBalanceInfo2.maxEarning
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Flex, {
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            gap: "4px",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(FaydaPointIcon, {
                                                                    size: "20px"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    children: data === null || data === void 0 ? void 0 : (_data_customerBalanceInfo3 = data.customerBalanceInfo) === null || _data_customerBalanceInfo3 === void 0 ? void 0 : _data_customerBalanceInfo3.potentialEarning
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(TabPanel, {
                                    children: /*#__PURE__*/ _jsx(Trans, {
                                        i18nKey: data === null || data === void 0 ? void 0 : data.popupWording.generalInfo.programInfo.value,
                                        components: {
                                            1: /*#__PURE__*/ _jsx(Box, {
                                                as: "span",
                                                fontWeight: 600
                                            })
                                        }
                                    })
                                }),
                                (data === null || data === void 0 ? void 0 : (_data_popupWording2 = data.popupWording) === null || _data_popupWording2 === void 0 ? void 0 : (_data_popupWording_generalInfo2 = _data_popupWording2.generalInfo) === null || _data_popupWording_generalInfo2 === void 0 ? void 0 : (_data_popupWording_generalInfo_programCashbackInfo1 = _data_popupWording_generalInfo2.programCashbackInfo) === null || _data_popupWording_generalInfo_programCashbackInfo1 === void 0 ? void 0 : _data_popupWording_generalInfo_programCashbackInfo1.key) ? /*#__PURE__*/ _jsxs(TabPanel, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Trans, {
                                            i18nKey: data === null || data === void 0 ? void 0 : (_data_popupWording3 = data.popupWording) === null || _data_popupWording3 === void 0 ? void 0 : (_data_popupWording_generalInfo3 = _data_popupWording3.generalInfo) === null || _data_popupWording_generalInfo3 === void 0 ? void 0 : _data_popupWording_generalInfo3.programCashbackInfo.value,
                                            components: {
                                                1: /*#__PURE__*/ _jsx(Box, {
                                                    as: "span",
                                                    fontWeight: 600
                                                })
                                            }
                                        }),
                                        /*#__PURE__*/ _jsxs(Box, {
                                            maxW: "300px",
                                            mb: 6,
                                            children: [
                                                /*#__PURE__*/ _jsxs(Flex, {
                                                    justify: "space-between",
                                                    align: "center",
                                                    mb: 2,
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            fontWeight: 600,
                                                            children: t('loyalty.transaction')
                                                        }),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            fontWeight: 600,
                                                            children: t('loyalty.cashback')
                                                        })
                                                    ]
                                                }),
                                                cashbackData.map((item, index)=>/*#__PURE__*/ _jsxs(Flex, {
                                                        justify: "space-between",
                                                        align: "center",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Text, {
                                                                children: item.operation
                                                            }),
                                                            /*#__PURE__*/ _jsx(Text, {
                                                                children: item.cashback
                                                            })
                                                        ]
                                                    }, index))
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Trans, {
                                            i18nKey: data === null || data === void 0 ? void 0 : (_data_popupWording4 = data.popupWording) === null || _data_popupWording4 === void 0 ? void 0 : (_data_popupWording_generalInfo4 = _data_popupWording4.generalInfo) === null || _data_popupWording_generalInfo4 === void 0 ? void 0 : _data_popupWording_generalInfo4.programCashback.value,
                                            components: {
                                                1: /*#__PURE__*/ _jsx(Box, {
                                                    as: "span",
                                                    fontWeight: 600
                                                })
                                            }
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(Trans, {
                    i18nKey: data === null || data === void 0 ? void 0 : data.popupWording.generalInfo.programInfo.value,
                    components: {
                        1: /*#__PURE__*/ _jsx(Box, {
                            as: "span",
                            fontWeight: 600
                        })
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ModalFooter, {
                shadow: "none",
                p: 6,
                justifyContent: "space-between",
                alignItems: {
                    base: 'flex-end',
                    md: 'center'
                },
                flexDirection: {
                    base: 'column',
                    md: 'row'
                },
                children: !(data === null || data === void 0 ? void 0 : data.isRegistered) ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            width: "100%",
                            mb: 6,
                            children: [
                                /*#__PURE__*/ _jsx(Checkbox, {
                                    onChange: (e)=>setTerms({
                                            ...terms,
                                            checked: e.target.checked
                                        }),
                                    isChecked: terms.checked,
                                    mr: 2,
                                    sx: {
                                        '&>.chakra-checkbox__control': {
                                            borderColor: 'semantic.onSurface.quaternary !important',
                                            borderWidth: '2px !important'
                                        }
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    as: "span",
                                    fontSize: "sm",
                                    children: /*#__PURE__*/ _jsx(Trans, {
                                        i18nKey: "loyalty.terms_approve",
                                        components: {
                                            1: /*#__PURE__*/ _jsx(Link, {
                                                color: "brand.abb.primary",
                                                onClick: ()=>setTerms({
                                                        ...terms,
                                                        isOpen: true
                                                    })
                                            })
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: isRegister,
                            isDisabled: !terms.checked,
                            children: t('loyalty.active')
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(Flex, {
                    w: "100%",
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ _jsx(Button, {
                        variant: "gray",
                        onClick: ()=>{
                            onClose();
                            navigate('/payments/point?page=1');
                        },
                        children: t('loyalty.view_history')
                    })
                })
            })
        ]
    });
};
